import { type CommandBarAction } from '../store/schema/CommandBarAction';

// The default configuration for the command bar buttons
export default [0, 1, 2, 3, 4, 5, 6, 7, 8, 18, 19, 9, 10, 11, 12, 13, 14, 17, 15, 16];
